import { render } from "./System-Settings.vue?vue&type=template&id=3c573a82&scoped=true"
import script from "./System-Settings.vue?vue&type=script&lang=js"
export * from "./System-Settings.vue?vue&type=script&lang=js"

import "./System-Settings.vue?vue&type=style&index=0&id=3c573a82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c573a82"]])

export default __exports__